import Router from './views/Router';
import './styles/main.scss';

const App = () => <Router />;

export default App;
